export default "__VITE_ASSET__CGVxLgMn__"